<div>
    <app-tool-bar [title]="'WhatsApp Template'" [iconName]="'pi-whatsapp'" (handleAdd)="isAddTemplate = true"
        [isAdd]="true" [isRefresh]="true" (handleRefresh)="refreshStatus()"></app-tool-bar>
</div>

<div class="p-3 overflow-y-auto h-[85vh]">
    <!-- WhatsApp Configuration Required Alert Banner -->
    <div *ngIf="showWhatsappConfigAlert" class="mb-4 bg-gradient-to-r from-green-50 to-emerald-50 border-l-4 border-green-500 rounded-lg shadow-lg overflow-hidden w-full lg:max-w-3xl m-auto ">
        <div class="p-6">
            <div class="flex items-start gap-4">
                <div class="flex-shrink-0">
                    <div class="w-12 h-12 rounded-full bg-gradient-to-br from-green-400 to-green-600 flex items-center justify-center shadow-md">
                        <i class="pi pi-exclamation-triangle text-2xl text-white"></i>
                    </div>
                </div>
                <div class="flex-1">
                    <h3 class="text-xl font-bold text-gray-900 mb-2">
                        WhatsApp Configuration Required
                    </h3>
                    <p class="text-gray-700 mb-4">
                        Please add your WhatsApp configuration to create and manage WhatsApp templates.
                    </p>
                    <div class="bg-white rounded-lg p-4 mb-4 border border-green-100">
                        <div class="space-y-3">
                            <div class="flex items-start gap-3">
                                <div class="w-8 h-8 rounded-full bg-green-500 text-white flex items-center justify-center font-semibold flex-shrink-0 text-sm">1</div>
                                <div class="pt-1">
                                    <p class="font-semibold text-gray-900 text-sm">Navigate to Configuration Panel</p>
                                    <p class="text-xs text-gray-600">Go to Settings > Configuration Panel.</p>
                                </div>
                            </div>
                            <div class="flex items-start gap-3">
                                <div class="w-8 h-8 rounded-full bg-green-500 text-white flex items-center justify-center font-semibold flex-shrink-0 text-sm">2</div>
                                <div class="pt-1">
                                    <p class="font-semibold text-gray-900 text-sm">Enter WhatsApp Details</p>
                                    <p class="text-xs text-gray-600">Fill in your WhatsApp Business API credentials (Email, API Key, App Name, Source).</p>
                                </div>
                            </div>
                            <div class="flex items-start gap-3">
                                <div class="w-8 h-8 rounded-full bg-green-500 text-white flex items-center justify-center font-semibold flex-shrink-0 text-sm">3</div>
                                <div class="pt-1">
                                    <p class="font-semibold text-gray-900 text-sm">Save Configuration</p>
                                    <p class="text-xs text-gray-600">Click Save to activate WhatsApp messaging capabilities.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button (click)="navigateToWhatsappConfig()" 
                        class="px-6 py-2.5 bg-gradient-to-r from-green-500 to-green-600 text-white font-semibold rounded-lg shadow-md hover:shadow-lg hover:from-green-600 hover:to-green-700 transition-all duration-200 transform hover:-translate-y-0.5">
                        <i class="pi pi-cog mr-2"></i>
                        Add WhatsApp Configuration
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- WhatsApp Templates Table - Only show if configuration exists -->
    <div *ngIf="!showWhatsappConfigAlert">
    <p-table [value]="templateData" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [lazy]="true"
        (onLazyLoad)="loadData($event)" [(selection)]="selectedTemplates" [loading]="loading"
        [rowsPerPageOptions]="totalRecords > 10 ? [10, 20, 50] : undefined" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of displayedColumns" [pSortableColumn]="col.sortable ? col.field : ''">
                    {{ col.header }}
                    <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-customer let-i="rowIndex" let-rowData>
            <tr>
                <td *ngFor="let col of displayedColumns">
                    <ng-container [ngSwitch]="col.type">

                        <ng-container *ngSwitchCase="'template_name'" style="margin-left: 10px;">
                            <div class="text-[15px] font-semibold " style="font-size: 18px;
                            margin-bottom: 6px;">
                                {{ rowData?.elementName }}
                            </div>

                            <div class="text-sm font-medium mb-2">
                                Template Id: {{ rowData?.appId }}
                            </div>

                            <div class="template_Data" [innerHTML]="formatMessage2(rowData.data)"></div>

                            <div class="flex gap-5 items-center mt-3">
                                <div
                                    class=" px-2 py-1 rounded-md text-xs tracking-wide border border-solid border-gray-300">
                                    {{ rowData.category }}
                                </div>

                                <div>
                                    <span class="font-semibold">Language:</span>
                                    <span> {{ rowData.languageCode }},</span>
                                </div>

                                <div>
                                    <span class="font-semibold">Type:</span>
                                    <span class="capitalize">{{ rowData.templateType }}</span>
                                </div>
                            </div>

                        </ng-container>

                        <ng-container *ngSwitchCase="'status'">
                            <div class="flex items-center gap-2 min-w-[150px]">
                                <div class="status_chip" style="background-color: #f0fdf2;"
                                    *ngIf="rowData.status ==='APPROVED'">
                                    <img src="assets/svg/ic_approved.svg" alt="Active" class="statusimg" />
                                    <div class="text-black">
                                        Approved
                                    </div>
                                </div>

                                <!-- // Failed -->
                                <div class="status_chip" style="background-color: #feefef;"
                                    *ngIf="rowData.status ==='FAILED'">
                                    <img src="assets/svg/rejected.svg" alt="Active" class="statusimg" />
                                    <div class="text-black">
                                        Failed
                                    </div>
                                </div>

                                <!-- // Pending -->
                                <div style="background-color: #ffeada;" class="status_chip"
                                    *ngIf="rowData.status ==='PENDING'">
                                    <img src="assets/svg/pending.svg" alt="Active" class="statusimg" />
                                    <div class="text-black">
                                        Pending
                                    </div>
                                </div>

                                <!-- // Rejected -->
                                <div style="background-color: #feefef;" class="status_chip"
                                    *ngIf="rowData.status ==='REJECTED'">
                                    <img src="assets/svg/rejected.svg" alt="Active" class="statusimg" />
                                    <div class="text-black">
                                        Rejected
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <!-- Handle Actions -->
                        <ng-container *ngSwitchCase="'actions'">
                            <div *ngIf="rowData.status !=='REJECTED' && rowData.status !=='FAILED'"
                                (click)="setTemplateEditData(rowData)" class="cursor-pointer min-w-[100px]">
                                <p-menu [tabindex]="undefined" #menu [model]="templateActionItems" [popup]="true"
                                    appendTo="body"></p-menu>
                                <i (click)="menu.toggle($event)" class="pi pi-ellipsis-h action-button"></i>
                            </div>

                            <div *ngIf="rowData.status ==='REJECTED' || rowData.status ==='FAILED'"
                                (click)="setTemplateEditData(rowData)" class="cursor-pointer min-w-[100px]">
                                <p-menu [tabindex]="undefined" #menu [model]="templateActionItems2" [popup]="true"
                                    appendTo="body"></p-menu>
                                <i (click)="menu.toggle($event)" class="pi pi-ellipsis-h action-button"></i>
                            </div>
                        </ng-container>

                        <!-- Default Case (Normal Field) -->
                        <ng-container *ngSwitchDefault>
                            {{ rowData[col.field] }}
                        </ng-container>
                    </ng-container>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="loading">
            <tr>
                <td colspan="3" class="text-center">
                    <p-progressSpinner></p-progressSpinner>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="displayedColumns.length + 1" class="no-data-record-found">
                    <p>No records found</p>
                </td>
            </tr>
        </ng-template>
    </p-table>
    </div>

<p-dialog [modal]="true" [(visible)]="isAddTemplate" [breakpoints]="{ '1199px': '80vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '80vw' }" [draggable]="false" [resizable]="false">
    <ng-container *ngIf="isAddTemplate">
        <app-create-whatsapp-template (reload)="reloadTable()" [contactGroupColumns]="contactGroupColumns"
            (closeDialog)="isAddTemplate = false"></app-create-whatsapp-template>
    </ng-container>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="isEditTemplate" [breakpoints]="{ '1199px': '80vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '80vw' }" [draggable]="false" [resizable]="false">
    <ng-container *ngIf="isEditTemplate">
        <app-create-whatsapp-template 
        [mappingDataToEdit]="mappingDataToEdit"
        (reload)="reloadTable()" [type]="'Edit'" [templateDataToEdit]="templateToEdit"
            [contactGroupColumns]="contactGroupColumns" (closeDialog)="isEditTemplate = false"></app-create-whatsapp-template>
    </ng-container>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="isPreview" [breakpoints]="{ '1199px': '50vw', '575px': '90vw' }" closable="false"
    [style]="{ width: '30vw' }" [draggable]="false" [resizable]="false">
    <ng-container *ngIf="isPreview">
        <app-preview-whatsapp-template (reload)="reloadTable()" [templateDataToEdit]="templateToEdit"
            (closeDialog)="isPreview = false"></app-preview-whatsapp-template>
    </ng-container>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="isOpenRejectionReason" [breakpoints]="{ '1199px': '60vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">

    <div class="flex items-center justify-center dialog-header ">
        Rejected Reason

        <div class="absolute right-2">
            <button (click)="isOpenRejectionReason = false" class="outline-none p-5">
                <i class="pi pi-times"></i>
            </button>
        </div>

    </div>

    <div class="dialog-content">
        <div class="mt-2 mb-2" style="font-weight: 500; font-size: 17px; color: red; text-align: center;">
            {{templateToEdit?.reason}}
        </div>
    </div>

</p-dialog>


<p-dialog [modal]="true" [(visible)]="isDeleteTemplate" [breakpoints]="{ '1199px': '60vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">

    <div class="flex items-center justify-center dialog-header ">
        Delete Template

        <div class="absolute right-2">
            <button (click)="isDeleteTemplate = false" class="outline-none p-5">
                <i class="pi pi-times"></i>
            </button>
        </div>

    </div>

    <div class="dialog-content">
        <div class="mt-2 mb-2" style="font-weight: 500; font-size: 17px; text-align: center;">
            Are you sure you want to delete this template : {{templateToEdit?.elementName}}?
        </div>

        <div class="flex gap-4 mt-7 justify-end">

            <p-button label="Cancel" severity="danger" variant="outlined" (click)="isDeleteTemplate = false"></p-button>
            <p-button label="Delete" severity="danger" icon="pi pi-trash" (click)="handleDelete()"
                [disabled]="isLoading" [loading]="isLoading">
            </p-button>


        </div>

    </div>

</p-dialog>